import React from 'react';

const currentSite =
  process.env.SHELTER_SITE === 'england' ? 'England and Wales' : 'Scotland';

const siblingIsh =
  process.env.SHELTER_SITE === 'england' ? 'Scottish' : 'English and Welsh';

const AlternativeLink =
  process.env.SHELTER_SITE === 'england'
    ? () => <a href="https://scotland.shelter.org.uk">Shelter Scotland</a>
    : () => <a href="https://england.shelter.org.uk">Shelter England</a>;

/**
 * This is displayed to the user where their result is determined to be out of bounds for the current site
 * i.e. an English query on the Scotland site, or a Scottish query on the England site.
 */
const OutOfBounds = () => (
  <p>
    This service only covers {currentSite}. You can find information about{' '}
    {siblingIsh} services by searching on <AlternativeLink />
  </p>
);

export default OutOfBounds;
